//
// Copyright (C) 2025 The Android Open Source Project
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.7.0 with parameter "target=ts,import_extension=none"
// @generated from file android/hardware/automotive/vehicle/GetMinMaxSupportedValuesTypes.proto (package android.hardware.automotive.vehicle.proto, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PropIdAreaId } from "./PropIdAreaId_pb";
import { file_android_hardware_automotive_vehicle_PropIdAreaId } from "./PropIdAreaId_pb";
import type { RawPropValues } from "./RawPropValues_pb";
import { file_android_hardware_automotive_vehicle_RawPropValues } from "./RawPropValues_pb";
import type { StatusCode } from "./StatusCode_pb";
import { file_android_hardware_automotive_vehicle_StatusCode } from "./StatusCode_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file android/hardware/automotive/vehicle/GetMinMaxSupportedValuesTypes.proto.
 */
export const file_android_hardware_automotive_vehicle_GetMinMaxSupportedValuesTypes: GenFile = /*@__PURE__*/
  fileDesc("CkdhbmRyb2lkL2hhcmR3YXJlL2F1dG9tb3RpdmUvdmVoaWNsZS9HZXRNaW5NYXhTdXBwb3J0ZWRWYWx1ZXNUeXBlcy5wcm90bxIpYW5kcm9pZC5oYXJkd2FyZS5hdXRvbW90aXZlLnZlaGljbGUucHJvdG8ikQIKGk1pbk1heFN1cHBvcnRlZFZhbHVlUmVzdWx0EkUKBnN0YXR1cxgBIAEoDjI1LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlN0YXR1c0NvZGUSVQoTbWluX3N1cHBvcnRlZF92YWx1ZRgCIAEoCzI4LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlJhd1Byb3BWYWx1ZXMSVQoTbWF4X3N1cHBvcnRlZF92YWx1ZRgDIAEoCzI4LmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLlJhd1Byb3BWYWx1ZXMicwofR2V0TWluTWF4U3VwcG9ydGVkVmFsdWVzUmVxdWVzdBJQCg9wcm9wX2lkX2FyZWFfaWQYASADKAsyNy5hbmRyb2lkLmhhcmR3YXJlLmF1dG9tb3RpdmUudmVoaWNsZS5wcm90by5Qcm9wSWRBcmVhSWQidwoeR2V0TWluTWF4U3VwcG9ydGVkVmFsdWVzUmVzdWx0ElUKBnJlc3VsdBgBIAMoCzJFLmFuZHJvaWQuaGFyZHdhcmUuYXV0b21vdGl2ZS52ZWhpY2xlLnByb3RvLk1pbk1heFN1cHBvcnRlZFZhbHVlUmVzdWx0YgZwcm90bzM", [file_android_hardware_automotive_vehicle_PropIdAreaId, file_android_hardware_automotive_vehicle_RawPropValues, file_android_hardware_automotive_vehicle_StatusCode]);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.MinMaxSupportedValueResult
 */
export type MinMaxSupportedValueResult = Message<"android.hardware.automotive.vehicle.proto.MinMaxSupportedValueResult"> & {
  /**
   * *
   * The status for result. If this is not OK, the operation failed for this
   * [propId, areaId].
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.StatusCode status = 1;
   */
  status: StatusCode;

  /**
   * *
   * The min supported value.
   *
   * If the [propId, areaId] does not specify a min supported value, this
   * is {@code null}.
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.RawPropValues min_supported_value = 2;
   */
  minSupportedValue?: RawPropValues;

  /**
   * *
   * The max supported value.
   *
   * If the [propId, areaId] does not specify a max supported value, this
   * is {@code null}.
   *
   * This must be ignored if status is not {@code StatusCode.OK}.
   *
   * @generated from field: android.hardware.automotive.vehicle.proto.RawPropValues max_supported_value = 3;
   */
  maxSupportedValue?: RawPropValues;
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.MinMaxSupportedValueResult.
 * Use `create(MinMaxSupportedValueResultSchema)` to create a new message.
 */
export const MinMaxSupportedValueResultSchema: GenMessage<MinMaxSupportedValueResult> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_GetMinMaxSupportedValuesTypes, 0);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.GetMinMaxSupportedValuesRequest
 */
export type GetMinMaxSupportedValuesRequest = Message<"android.hardware.automotive.vehicle.proto.GetMinMaxSupportedValuesRequest"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.PropIdAreaId prop_id_area_id = 1;
   */
  propIdAreaId: PropIdAreaId[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.GetMinMaxSupportedValuesRequest.
 * Use `create(GetMinMaxSupportedValuesRequestSchema)` to create a new message.
 */
export const GetMinMaxSupportedValuesRequestSchema: GenMessage<GetMinMaxSupportedValuesRequest> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_GetMinMaxSupportedValuesTypes, 1);

/**
 * @generated from message android.hardware.automotive.vehicle.proto.GetMinMaxSupportedValuesResult
 */
export type GetMinMaxSupportedValuesResult = Message<"android.hardware.automotive.vehicle.proto.GetMinMaxSupportedValuesResult"> & {
  /**
   * @generated from field: repeated android.hardware.automotive.vehicle.proto.MinMaxSupportedValueResult result = 1;
   */
  result: MinMaxSupportedValueResult[];
};

/**
 * Describes the message android.hardware.automotive.vehicle.proto.GetMinMaxSupportedValuesResult.
 * Use `create(GetMinMaxSupportedValuesResultSchema)` to create a new message.
 */
export const GetMinMaxSupportedValuesResultSchema: GenMessage<GetMinMaxSupportedValuesResult> = /*@__PURE__*/
  messageDesc(file_android_hardware_automotive_vehicle_GetMinMaxSupportedValuesTypes, 2);

